import angular from 'angular';

/**
 * Legacy module — preserved as empty so deps keep resolving.
 * Real implementation: apps/b2b-frontend/app/core/lunch-litely/lunch-litely.service.ts
 * Registered via downgradeInjectable in
 * apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts
 */
export { LunchLitelyService } from '@ng/core/lunch-litely/lunch-litely.service';
export type { FlagContext } from '@ng/core/lunch-litely/lunch-litely.service';

export const LunchLitelyServiceModule = angular.module('acme.common.service.lunchLitely', []).name;
